import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

const FloatingUI = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!showScrollTop) return null;

  return (
    <button
      type="button"
      onClick={handleScrollTop}
      className="
        fixed
        bottom-4 right-4 md:bottom-6 md:right-6
        z-40
        inline-flex
        h-11 w-11
        items-center justify-center
        rounded-full
        bg-[#7ED956]
        text-white
        shadow-lg
        hover:bg-[#6BCB45]
        transition
      "
      aria-label="Scroll naar boven"
      data-testid="scroll-to-top-button"
    >
      <ChevronUp className="h-6 w-6" aria-hidden="true" />
    </button>
  );
};

export default FloatingUI;
